import { SharedConstants } from "../../shared/constants/shared.constants";
export class UnsecureCaptureCommentConstants {
    static COMPONENT_TYPE = "Public Capture Comment";
    static TITLE = "Capture Comment";
    static BUSINESS_UNIT_LABEL = "Business Unit";
    static COMMENT_TEXT_LABEL = "Comment";
    static CAPTURE_DATE_LABEL = "Captured Date";
    static FIRST_NAME_TEXT_LABEL = "First Name";
    static LAST_NAME_TEXT_LABEL = "Last Name";
    static EMAIL_TEXT_LABEL = "Email Adress";
    static CONTACTNO_TEXT_LABEL = "Contact Number";
    static COMMENT_FORM_GROUP = "commentFormGroup";
    static BUSINESS_UNIT_FORM_CONTROL = "businessUnitFormControl";
    static COMMENT_TEXT_FORM_CONTROL = "commentText";
    static CAPTURE_DATE_FORM_CONTROL = "captureDateFormControl";
    static FIRST_NAME_FORM_CONTROL = "firstNameFormControl";
    static LAST_NAME_FORM_CONTROL = "lastNameFormControl";
    static EMAIL_FORM_CONTROL = "emailFormControl";
    static CONTACTNO_FORM_CONTROL = "contactNoFormControl";
    static ATTACHMENT_MANAGER_FORM_CONTROL = "attachmentManager";
    static HTML_EDITOR_CONFIG = "noImage";
    static COMMENT_STATUS_CLOSED = "Closed";
    static COMMENT_LOOKUP_TYPE = "BusinessUnit";
    static COMMENT_TYPE = "External";
    static ATTACHMENT_TYPE = "PublicComment";
    static BUSINESS_UNITS_EMPTY_MESSAGE = "Business Units not configured correcly";
    static CAPTURE_NOT_ALLOWED = "Request for comment has expired";
    static UNAUTHORIZED_TEXT = "You are not Authorized to view this page";
    static VALIDATION_MESSAGE_CONST = {
        capturedDate: "Please enter captured date.",
        businessUnit: "Please select business unit.",
        firstName: "Please enter first name",
        lastName: "Please enter last name",
        commentCapturedBy: "Please select comment captured by.",
        comment: "Please enter a comment.",
        email: {
            email: SharedConstants.EMAIL_VALIDATION_MESSAGE,
            maxlength: `Email ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "250")}`,
        },
        contactNo: {
            contactNo: SharedConstants.PHONE_NUMBER_VALIDATION_MESSAGE,
            maxlength: `Telephone ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "20")}`,
        },
    };
}
